export class BarrelSplitRun {
    updated: string;
    eyeBreaks: any[];
    splitRuns: any[];

    straightOneSplit: number;
    aroundBarrelOneSplit: number;
    straightTwoSplit: number;
    aroundBarrelTwoSplit: number;
    straightThreeSplit: number;
    aroundBarrelThreeSplit: number;
    straightFourSplit: number;

    totalTime: string;
    goingLeft: boolean;
    done: boolean;

    constructor() {
        this.straightOneSplit = 999;
        this.aroundBarrelOneSplit = 999;
        this.straightTwoSplit = 999;
        this.aroundBarrelTwoSplit = 999;
        this.straightThreeSplit = 999;
        this.aroundBarrelThreeSplit = 999;
        this.straightFourSplit = 999;
    }
}


// WEBPACK FOOTER //
// ./src/model/barrel-split-run.ts